// src/components/Hero.jsx
import { ChevronDown } from "lucide-react";
import Particles from "./Particles";
import { useServerStatus } from "../hooks/useServerStatus";

const heroBg = {
  position: "absolute",
  inset: 0,
  background: [
    "radial-gradient(ellipse 100% 100% at 50% 0%, rgba(10,10,20,0) 0%, rgba(10,10,20,0.5) 50%, rgba(10,10,20,1) 90%)",
    "radial-gradient(ellipse 80% 60% at 50% 30%, rgba(55,15,95,.45) 0%, transparent 65%)",
    `url('${process.env.PUBLIC_URL}/background.png') center 10% / cover no-repeat`,
    "linear-gradient(180deg,#060610 0%,#0d0818 100%)",
  ].join(", "),
};

export default function Hero({
  heroHeight,
  onOpenStore,
  onCopyIP,
}) {
  const { minecraft, loaded } = useServerStatus();
  const mcOnline = loaded ? minecraft.online : null;

  return (
    <div className="toa-hero" style={{ height: heroHeight }}>
      <div style={heroBg} />

      <Particles />

      <div className="toa-hero-content">

        {/* TOA logo */}
        <div
  className="toa-hero-icon"
  style={{
    WebkitMaskImage: `url(${process.env.PUBLIC_URL}/icon.svg)`,
    maskImage: `url(${process.env.PUBLIC_URL}/icon.svg)`,
  }}
/>

        <div className="toa-hero-est">
          Est. 2024
        </div>

        <h1 className="toa-hero-title">
          The Ones Above
        </h1>

        <p className="toa-hero-slogan">
          <em>Rise Above.</em> Grow Together.
        </p>

        <div
          className="toa-hero-ip"
          onClick={onCopyIP}
        >
          <span className="toa-hero-ip-top">
            <div
              className="toa-dot"
              style={{
                background:
                  mcOnline === null
                    ? "#888"
                    : mcOnline
                    ? "#4ade80"
                    : "#ef4444",

                boxShadow:
                  mcOnline
                    ? "0 0 8px #4ade80"
                    : "none",

                flexShrink: 0,
              }}
            />

            <span className="toa-hero-ip-label">
              Minecraft&nbsp;·&nbsp;
              <strong>
                play.theonesabove.org
              </strong>
            </span>
          </span>

          <span className="toa-hero-ip-sep">
            &nbsp;·&nbsp;
          </span>

          <span
            className="toa-hero-ip-status"
            style={{
              color:
                mcOnline === null
                  ? "#888"
                  : mcOnline
                  ? "#4ade80"
                  : "#ef4444",
            }}
          >
            {mcOnline === null
              ? "Checking..."
              : mcOnline
              ? `Online · ${minecraft.playerCount}/${minecraft.maxPlayers}`
              : "Offline"}
          </span>
        </div>

        <div className="toa-hero-ctas">
          <a
            href="https://discord.gg/AzrauJnuqw"
            target="_blank"
            rel="noreferrer"
            className="toa-btn toa-btn-p"
            style={{
              fontSize: 14,
              padding: "13px 28px",
            }}
          >
            Join Discord
          </a>

          <a
            href="/minecraft"
            className="toa-btn toa-btn-ghost"
            style={{
              fontSize: 14,
              padding: "13px 28px",
            }}
          >
            Minecraft
          </a>

          <button
            className="toa-btn toa-btn-g"
            style={{
              fontSize: 14,
              padding: "13px 28px",
            }}
            onClick={onOpenStore}
          >
            Store
          </button>
        </div>
      </div>

      {/* Hidden on mobile via CSS class */}
      <div className="toa-hero-scroll">
        <ChevronDown className="toa-ico" />
        <div>Scroll</div>
      </div>
    </div>
  );
}